import ADMIN_UI from '../assets/png/ADMIN_UI.png';
import Sportsjam from '../assets/png/Sportsjam.png';
import TeerexStore from '../assets/png/TeerexStore.png';
import Nextapp from '../assets/png/Nextapp.png';
import myntra from '../assets/png/myntra.png';

export const projectsData = [
  {
    id: 1,
    projectName: 'Next Full Stach App',
    projectDesc:
      'Search Bar || Router || Suspense || Login || App router and Data Fetching',
    tags: ['FrontEnd', 'React', 'Next', 'PostgreSQL'],
    code: 'https://github.com/Luke0912/next-app',
    demo: 'https://next-app-iota-nine.vercel.app/',
    image: Nextapp,
  },
  {
    id: 2,
    projectName: 'Myntra.com',
    projectDesc:
      'Myntra website Clone Features:Login_SignUp||Landing Page||Product Section||Payment & CheckOut',
    tags: ['HTML', 'CSS', 'Javascript', 'FrontEnd'],
    code: 'https://github.com/Luke0912/myntra-app',
    demo: 'https://quizzical-goldstine-ff92bf.netlify.app/',
    image: myntra,
  },
  {
    id: 3,
    projectName: 'Sports-Jam',
    projectDesc:
      'Sports-Jam(E-Commerce sports website) website Clone backend database management Features:Login_SignUp||Landing Page||Product Section||Payment & CheckOut.  React||Node.js||Redux||Mongo||Json-server',
    tags: ['React', 'NodeJS', 'FrontEnd', 'BackEnd'],
    code: 'https://github.com/Luke0912/Sportsjam',
    demo: 'https://sports-jam.netlify.app/',
    image: Sportsjam,
  },
  {
    id: 4,
    projectName: 'Admin-UI',
    projectDesc:
      'TABLE || UI || PAGINATION || INMEMORY-EDIT & DELETE ||ROW-SELECTION',
    tags: ['React', 'FrontEnd'],
    code: 'https://github.com/Luke0912/Admin-UI',
    demo: 'https://admin-ui-geektr.netlify.app/',
    image: ADMIN_UI,
  },
  {
    id: 5,
    projectName: 'React-Redux Store',
    projectDesc:
      'Search Bar || Product Page || Category wise Filter || Add to cart || Edit cart item',
    tags: ['FrontEnd', 'React', 'Redux', 'JavaScript'],
    code: 'https://github.com/Luke0912/TeeRex_store',
    demo: 'https://teerex-shopee.netlify.app/',
    image: TeerexStore,
  },

  // {
  //     id: 6,
  //     projectName: 'Uber Lite',
  //     projectDesc: 'Uber clone',
  //     tags: ['Flutter'],
  //     code: 'https://github.com/hhhrrrttt222111/developer-portfolio',
  //     demo: 'https://github.com/hhhrrrttt222111/developer-portfolio',
  //     image: six
  // },
  // {
  //     id: 7,
  //     projectName: 'Stock Market App',
  //     projectDesc: 'A simple stock market API app',
  //     tags: ['React', 'Redux', 'Bootstrap'],
  //     code: 'https://github.com/hhhrrrttt222111/developer-portfolio',
  //     demo: 'https://github.com/hhhrrrttt222111/developer-portfolio',
  //     image: seven
  // },
  // {
  //     id: 8,
  //     projectName: 'Car Pooling System',
  //     projectDesc: 'The carpooling system merges multiple people in a car which leads to meet new people, reduces pollution',
  //     tags: ['Flutter', 'React'],
  //     code: 'https://github.com/hhhrrrttt222111/developer-portfolio',
  //     demo: 'https://github.com/hhhrrrttt222111/developer-portfolio',
  //     image: eight
  // },
];

// Do not remove any fields.
// Leave it blank instead as shown below

/* 
{
    id: 1,
    projectName: 'Car Pooling System',
    projectDesc: '',
    tags: ['Flutter', 'React'],
    code: '',
    demo: '',
    image: ''
}, 
*/
